export default __webpack_public_path__ + "static/media/ficha-notificacion-coronavirus.a205f6a8.pdf";